import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { SessionContext } from "../../common/SessionContext";

const scrollTop = () =>
  window.scrollTo({ top: 0, behavior: "smooth" });

function ConfirmWrapperArea(props) {

  // API configuration constants
  const API_URL = `${process.env.REACT_APP_API_FOLDER}get_unpaid_booking/${props.ctype}/${props.hash}`;
  const API_URL2 = `${process.env.REACT_APP_API_FOLDER}grantcode/`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  // State management for booking data, loading status, and error handling
  const [booking, setBooking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // state for the edition id
  const [editionId, setEditionId] = useState("");

  // Fetch booking data on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });
        setBooking(response.data);
        setEditionId(response.data.edition_id);
        setLoading(false);
      } catch (err) {
        console.error("API Error:", err);
        setError(err.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // runs once on mount

  let newPriceCode;

  const { session } = useContext(SessionContext);
  const currentCurrency = session.currency;

  // Pricing info from the booking data
  const fullAmount = booking?.pricing?.[currentCurrency]?.full_amount;
  const splitAmount = booking?.pricing?.[currentCurrency]?.split_amount;
  const fullAmountWW = booking?.pricing?.[currentCurrency]?.full_amount_inc_ww;
  const splitAmountWW = booking?.pricing?.[currentCurrency]?.split_amount_inc_ww;
  const workWeek = booking?.pricing?.[currentCurrency]?.work_week;
  const numberOfPayments = booking?.pricing?.[currentCurrency]?.number_of_payments;
  const currencySymbol = booking?.pricing?.[currentCurrency]?.symbol;

  // Local state values for final pricing (i.e. after applying discount)
  const [finalAmount, setFinalAmount] = useState("");
  const [finalSplitAmount, setFinalSplitAmount] = useState("");

  // On booking data update, update the final amounts if pricing is available
  useEffect(() => {
    if (booking?.pricing?.[currentCurrency]) {
      setFinalAmount(fullAmount);
      setFinalSplitAmount(
        fullAmount && numberOfPayments ? fullAmount / numberOfPayments : ""
      );
      handlePriceCode();
    }
  }, [
    booking,
    currentCurrency,
    fullAmount,
    fullAmountWW,
    numberOfPayments
  ]);

  // Slider state and user choices
  const [currentStep, setCurrentStep] = useState(0);
  const [extras, setExtras] = useState(null);
  const [addWw, setAddWw] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  // State for the grant code
  const [grantCode, setGrantCode] = useState("");
  // State to display a message using JSX based on grant code validity
  const [grantMsg, setGrantMsg] = useState("");
  // State to set the price code
  //Format is: [courseid]_[currency]_[discount]_[payments]_[plus7]
  const [priceCode, setPriceCode] = useState("");
  // state for the grantcode value
  const [discountValue, setDiscountValue] = useState("");
  // state for the grantcode type
  const [codeType, setCodeType] = useState("");

  // Set codeType based on props.ctype only once when props.ctype changes
  useEffect(() => {
    setCodeType(props.ctype == 'online' ? 'bundle' : 'grant');
  }, [props.ctype]);

  // Step navigation handlers
  const nextStep = () => setCurrentStep((prev) => prev + 1);
  const previousStep = () => setCurrentStep((prev) => prev - 1);

  const handleExtrasYes = () => {
    setExtras(true);
    setAddWw(1);
    setFinalAmount(fullAmountWW);
    handleDiscount(fullAmountWW, true);
    handlePriceCode(true);
    nextStep();
  };

  const handleExtrasNo = () => {
    setExtras(false);
    setAddWw(0);
    setFinalAmount(fullAmount);
    handleDiscount(fullAmount, false);
    handlePriceCode(false);
    nextStep();
  };

  // Handler for submitting the grant code
  const handleAddGrantCode = async (e) => {
    e.preventDefault();
    try {
      const gcresponse = await axios.post(
        API_URL2,
        { grantCode: grantCode, unpaidHash: props.hash, editionId: booking.edition_id, refctype: props.ctype },
        { headers: { "X-API-TOKEN": API_TOKEN } }
      );
      console.log("ed-id="+booking.edition_id);
      if (gcresponse.data.apply_dcode) {
        // Show a custom JSX grant message
        setGrantMsg(<span className="grantcode-pass">Code applied!</span>);

        //set the grant amount in state
        setDiscountValue(gcresponse.data.dcode_value);

        // Convert the original amounts from booking pricing to numbers.
        let cleanFullAmount = fullAmount.toString().replace(/[^0-9.]/g, "");
        let cleanFullAmountWW = fullAmountWW.toString().replace(/[^0-9.]/g, "");
        let originalFullAmount;
        if (extras) {
          originalFullAmount = Number(cleanFullAmountWW);
        } else {
          originalFullAmount = Number(cleanFullAmount);
        }

        const discountRaw = gcresponse.data.dcode_value;
        const discountCleaned = discountRaw.toString().replace(/[^0-9.]/g, ""); // Remove anything non-numerical
        const discount = Number(discountCleaned);

        const numPayments = Number(numberOfPayments);

        // Calculate new discounted amounts
        const newFinalAmount = Math.round(originalFullAmount * ((100 - discount) / 100));
        const newFinalSplitAmount = numPayments > 0 ? newFinalAmount / numPayments : "";

        // Update final amounts in state
        setFinalAmount(newFinalAmount);
        setFinalSplitAmount(newFinalSplitAmount);

        //update the price code
        handlePriceCode(extras, discount);

        //change the payment buttons
        //hide the pay_split form
        //change the text of button pay_full_button to Confirm (no payment required)
        if (newFinalAmount == 0) {
          document.getElementById("pay_split").style.display = "none";
          document.getElementById("pay_instruct").style.display = "none";
          document.getElementById("pay_full_button").textContent = "Confirm (no payment required)";
          document.getElementById("pay_full").action = "https://www.campfr.com/api/success";
        }

      } else {
        setGrantMsg(<span className="grantcode-fail">That code didn't work - {gcresponse.data.failcode}</span>);
      }
    } catch (err) {
      console.error("Error updating grant code:", err);
      setGrantMsg(<span className="grantcode-fail">Error applying code</span>);
    }
  };

  // Handler for discounted the price based on an already-submitted code
  const handleDiscount = (fullAmountValue = fullAmount, extrasValue = extras) => {
    if (discountValue !== '') {

      // Convert the original amounts from booking pricing to numbers.
      let cleanFullAmount = fullAmountValue.toString().replace(/[^0-9.]/g, "");
      let originalFullAmount = Number(cleanFullAmount);

      const discount = Number(discountValue); // For example, 90 for 90%
      const numPayments = Number(numberOfPayments);

      // Calculate new discounted amounts
      const newFinalAmount = Math.round(originalFullAmount * ((100 - discount) / 100));
      const newFinalSplitAmount = numPayments > 0 ? newFinalAmount / numPayments : "";

      // Update final amounts in state
      setFinalAmount(newFinalAmount);
      setFinalSplitAmount(newFinalSplitAmount);

    }
  }

  // course_id, ol if online, currency, discount, numpayments, ww
  const handlePriceCode = (extrasValue = extras, discountValueValue = discountValue) => {
    let newPriceCode = "";
    if (booking.pricecode_version == 2) {
      newPriceCode = "v2_";
    }
    newPriceCode += booking.course_id;
    if (props.ctype == 'online') {
      newPriceCode += "_ol";
    }
    newPriceCode += "_" + currentCurrency;
    newPriceCode += (discountValueValue !== '') ? "_" + discountValueValue : '';
    newPriceCode += "_" + numberOfPayments;
    newPriceCode += extrasValue ? "_ww" : '';
    setPriceCode(newPriceCode);
  };


  // Compute inline style for sliding container.
  const sliderStyle = {
    display: "flex",
    transform: `translateX(-${currentStep * 100}%)`,
    transition: "transform 0.5s ease",
    margin: 0,
    padding: 0,
    width: "100%"
  };

  return (
    <div className="contact-wrapper pt-110">
      <div className="container">
        <div className="row align-items-center justify-content-lg-center gy-5">
          <div className="col-lg-6">
            <div className="contatc-intro-figure">
              <img
                src={`${process.env.PUBLIC_URL}/images/banner/booked-bg.png`}
                alt="ContactBannerIMG"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="booked-info">
              <h3>Hey, {booking.firstname}!</h3>
              {currentStep > 0 && (
                <div className="back-link" style={{ marginBottom: "10px" }}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      previousStep();
                    }}
                    style={{
                      color: "#37bddb",
                      textDecoration: "none",
                      cursor: "pointer"
                    }}
                  >
                    <i className="fa-solid fa-arrow-left"></i> Back
                  </a>
                </div>
              )}
              <div
                className="slider-wrapper"
                style={{ overflow: "hidden", width: "100%" }}
              >
                <ul className="slider-container" style={sliderStyle}>
                  {/* Slide 1 */}
                  <li
                    className="confirmStep"
                    style={{
                      width: "100%",
                      listStyle: "none",
                      boxSizing: "border-box",
                      padding: "20px"
                    }}
                  >
                    <h6 className="mt-10">
                      You're one step away from confirming your place at CAMP for
                      this epic workshop.
                    </h6>
                    <button
                      className="button-fill-primary confirm-process-button"
                      onClick={nextStep}
                    >
                      Ok, let's go!
                    </button>
                  </li>
                  {/* Slide 1.2 (onsite only) */}
                  {props.ctype === "onsite" && (
                    <li
                      className="confirmStep"
                      style={{
                        width: "100%",
                        listStyle: "none",
                        boxSizing: "border-box",
                        padding: "20px"
                      }}
                    >
                      <p>
                        Now is the best time to decide if you want to <strong>add 7 nights</strong> to your stay. Hang out at CAMP
                        (with full catering), do some hiking, use our facilities, work
                        on your projects and process the past week. Full +7 info is <Link to="/plus7" onClick={scrollTop}>
                          here
                        </Link>.
                      </p>
                      <p>
                        It costs <strong>{currencySymbol}{workWeek}</strong>, which
                        covers full board accommodation and unlimited use of CAMP's
                        facilities. By adding +7 now, you can split the cost along with
                        the workshop fee. You can add this later, but you'll need to pay
                        the extra cost in full at that time.
                      </p>
                      <button
                        className="button-fill-primary confirm-process-button"
                        onClick={handleExtrasYes}
                      >
                        Yes, add +7
                      </button>
                      <button
                        className="button-fill-primary confirm-process-button"
                        onClick={handleExtrasNo}
                      >
                        No thanks
                      </button>
                    </li>
                  )}
                  {/* Slide 2 */}
                  <li
                    className="confirmStep"
                    style={{
                      width: "100%",
                      listStyle: "none",
                      boxSizing: "border-box",
                      padding: "20px"
                    }}
                  >
                    {extras ? (
                      <p>
                        The total cost of your workshop, including the extra 7 days, is{" "}
                        <strong>{currencySymbol}{finalAmount}</strong>.
                      </p>
                    ) : (
                      <p>
                        The total cost of your workshop is{" "}
                        <strong>{currencySymbol}{finalAmount}</strong>.
                      </p>
                    )}
                    <p id="pay_instruct">
                      Please select one of the options below – you can pay in full, or
                      start a {numberOfPayments}-month payment plan.
                    </p>



                    {props.ctype === "onsite" && (

                      <>
                        {/* Display the grant message above the input */}
                        {grantMsg && <div>{grantMsg}</div>}

                        <div className="grantcode-div" style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                          <input
                            type="text"
                            placeholder="Grant code"
                            id="grant_code"
                            value={grantCode}
                            onChange={(e) => setGrantCode(e.target.value)}
                            className="grantcode-input"
                            style={{ flex: 1 }}
                          />
                          <button
                            className="grantcode-button"
                            onClick={handleAddGrantCode}
                          >
                            Add code
                          </button>
                        </div>

                      </>
                    )}

                    {props.ctype === "online" && (

                      <>
                        {/* Display the grant message above the input */}
                        {grantMsg && <div>{grantMsg}</div>}

                        <div className="grantcode-div" style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                          <input
                            type="text"
                            placeholder="Grant, bundle or discount code"
                            id="grant_code"
                            value={grantCode}
                            onChange={(e) => setGrantCode(e.target.value)}
                            className="grantcode-input"
                            style={{ flex: 1 }}
                          />
                          <button
                            className="grantcode-button"
                            onClick={handleAddGrantCode}
                          >
                            Add code
                          </button>
                        </div>

                      </>
                    )}





                    <div style={{ display: "flex", gap: "10px" }}>

                      <form id="pay_full" action="https://www.campfr.com/api/checkout" method="POST">
                        <input type="hidden" name="product" value={booking.product} />
                        <input type="hidden" name="paymentType" value="payment" />
                        <input type="hidden" name="hash" value={props.hash} />
                        <input type="hidden" name="amount" value={finalAmount} />
                        <input type="hidden" name="currency" value={currentCurrency} />
                        <input type="hidden" name="priceCode" value={priceCode} />
                        <input type="hidden" name="ctype" value={props.ctype} />
                        <input type="hidden" name="add_ww" value={addWw} />
                        <input type="hidden" name="grantCode" value={grantCode} />
                        <input type="hidden" name="codeType" value={codeType} />
                        <input type="hidden" name="ws" value={booking.tracked_id} />
                        <button className="confirm-process-button" type="submit" id="pay_full_button">
                          Pay in full
                        </button>
                      </form>

                      <form id="pay_split" action="https://www.campfr.com/api/checkout" method="POST">
                        <input type="hidden" name="product" value={booking.product} />
                        <input type="hidden" name="paymentType" value="subscription" />
                        <input type="hidden" name="hash" value={props.hash} />
                        <input type="hidden" name="amount" value={finalAmount} />
                        <input type="hidden" name="currency" value={currentCurrency} />
                        <input type="hidden" name="priceCode" value={priceCode} />
                        <input type="hidden" name="ctype" value={props.ctype} />
                        <input type="hidden" name="add_ww" value={addWw} />
                        <input type="hidden" name="ws" value={booking.tracked_id} />
                        <button className="confirm-process-button" type="submit">
                          Split over {numberOfPayments} months
                        </button>
                      </form>
                    </div>
                    <div>
                    By signing up to a workshop, you agree to the <Link to="/terms" target="_blank" onClick={scrollTop}>terms</Link>
                    </div>
                  </li>
                </ul>
              </div>
              <p>
                <i>
                  If you have any questions about the workshop, the booking process or
                  anything else, check the
                  <Link to="/faq" onClick={scrollTop}>
                    FAQ
                  </Link>
                  , or <a href="mailto:hello@campfr.com">drop us a line</a>.
                </i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmWrapperArea;
